module.exports = __webpack_public_path__ + "fonts/iconfont.e436928f.ttf";